// extracted by css-extract-rspack-plugin
export default {"pendingActions":"pendingActions-J0rGj2 text-xs"};